import React from "react";
import {withStyles} from "@material-ui/core/styles";

import projectsStyle
	from "assets/jss/material-kit-pro-react/views/sectionsSections/projectsStyle.js";
import GridItem from "../../components/Grid/GridItem";

import SVG from "react-inlinesvg";
import GridContainer from "../../components/Grid/GridContainer";
import Rose from "../../components/Typography/Rose";

import intl from 'react-intl-universal';


class EmptyCard extends React.Component {


	constructor(props, context) {
		super(props, context);
		this.state = {
			headText: '',
			infoText: '',
			svgUrl: ''
		};


		switch (this.props.type) {
			case "series_learn":
				this.state.headText = intl.get('empty_finish_courses');
				this.state.infoText = intl.get('empty_finish_courses_info');
				this.state.svgUrl = require('../../assets/svg/empty_series_learn.svg');
				break;
			case "series_ready":
				this.state.headText = intl.get('empty_finish_courses_finish');
				this.state.infoText = <div>{intl.get('empty_finish_courses_1')}<Rose><a href="/series" target={'_blank'}>{intl.get('empty_finish_courses_2')}</a></Rose>{intl.get('empty_finish_courses_3')}</div>;
				this.state.svgUrl = require('../../assets/svg/empty_series_ready.svg');
				break;
			default:
				break
		}
	}

	render() {
		const {classes} = this.props;
		return (

			<div className={classes.container}>
				<GridContainer justify="center">
					<GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
						<h4 className={classes.title} style={{color: "white"}}>
							<b>{this.state.headText}</b>
						</h4>
						<h5 className={classes.title} style={{color: "#fff"}}>
							{this.state.infoText}
						</h5>
						<SVG src={this.state.svgUrl}
							 style={{
								 maxHeight: '500px', maxWidth: '100%'
							 }}
						/>
					</GridItem>
				</GridContainer>
			</div>
		);
	}
}

export default withStyles(projectsStyle)(EmptyCard)